/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Email_Copied_To_ClipboardInputs */

const en_mobile_email_copied_to_clipboard = /** @type {(inputs: Mobile_Email_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email copied to clipboard`)
};

const es_mobile_email_copied_to_clipboard = /** @type {(inputs: Mobile_Email_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico copiado al portapapeles`)
};

/**
* | output |
* | --- |
* | "Email copied to clipboard" |
*
* @param {Mobile_Email_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_email_copied_to_clipboard = /** @type {((inputs?: Mobile_Email_Copied_To_ClipboardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Email_Copied_To_ClipboardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_email_copied_to_clipboard(inputs)
	return en_mobile_email_copied_to_clipboard(inputs)
});